"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M9.017 0h.01c.78.016 1.538.33 2.084.875.255.254.454.598.613.932.099.21.19.435.275.666a7.98 7.98 0 0 1 .276-.666c.159-.334.358-.678.613-.932 1.163-1.162 3.11-1.162 4.27 0 1.004 1.005 1.174 2.458.506 3.613h3.665a2.667 2.667 0 0 1 2.666 2.665v2.986a2.669 2.669 0 0 1-2.24 2.631v8.565A2.667 2.667 0 0 1 19.09 24H4.163a2.668 2.668 0 0 1-2.666-2.665v-8.803a2.667 2.667 0 0 1-1.492-2.393V7.153A2.667 2.667 0 0 1 2.67 4.488h3.665c-.668-1.155-.499-2.607.507-3.613C7.436.281 8.247.008 9.006 0h.01Zm5.56 3.892c-.198.067-.41.132-.629.194.063-.219.128-.431.194-.628a6.76 6.76 0 0 1 .258-.665 1.813 1.813 0 0 1 .146-.261c.237-.232.684-.268.955.002.29.29.29.665 0 .954l.001-.001s-.016.014-.06.04a1.94 1.94 0 0 1-.2.107c-.174.081-.4.169-.666.258Zm-4.526.194a13.93 13.93 0 0 1-.627-.193 6.531 6.531 0 0 1-.665-.259 2.032 2.032 0 0 1-.201-.106c-.044-.027-.06-.041-.06-.041l.001.001c-.29-.29-.29-.663 0-.954a.65.65 0 0 1 .467-.189h.02a.697.697 0 0 1 .467.189l-.001-.002s.014.017.04.06c.03.048.066.115.107.201.081.174.169.4.258.666.067.196.132.408.194.627ZM7.853 6.833H2.67a.321.321 0 0 0-.321.32v2.986c0 .175.144.32.32.32h18.66a.322.322 0 0 0 .322-.32V7.153a.322.322 0 0 0-.322-.32h-5.182c.043.034.085.069.124.103a1.171 1.171 0 1 1-1.528 1.777c-.294-.251-.82-.576-1.421-.904A31.36 31.36 0 0 0 12 7.13a30.48 30.48 0 0 0-1.322.678c-.601.329-1.128.653-1.422.904a1.17 1.17 0 0 1-1.655-.127 1.171 1.171 0 0 1 .128-1.65l.124-.103ZM3.84 12.805v8.53a.32.32 0 0 0 .321.32H19.09c.177 0 .32-.146.32-.32v-8.53H3.842Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};